module.exports = __webpack_public_path__ + "static/media/person-remove-icon.ad0c995e.svg";